import React from "react";
import RevenueReports from "./RevenueReport";

export default function RevenueReportsDash() {
  const listdata = [
    { value: "total_revenue_by_mda", title: "Revenue Summary Reports by MDA" },
    { value: "revenue_by_dep", title: "Revenue Summary Reports by Department" },
  ];
  return (
    <div>
      <RevenueReports
        type="total_revenue_by_mda"
        route="/reports"
        options={listdata}
        title="Revenue Summary Reports by MDA"
      />
    </div>
  );
}
